import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
import { FieldPolicy, FieldReadFunction, TypePolicies, TypePolicy } from '@apollo/client/cache';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = {
  [_ in K]?: never;
};
export type Incremental<T> =
  | T
  | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
const defaultOptions = {} as const;
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string };
  String: { input: string; output: string };
  Boolean: { input: boolean; output: boolean };
  Int: { input: number; output: number };
  Float: { input: number; output: number };
  Cursor: { input: any; output: any };
  Id: { input: string; output: string };
  Timestamp: { input: string; output: string };
};

export type Annotation = {
  __typename?: 'Annotation';
  content: Scalars['String']['output'];
  coordinates: LatLng;
  createdAt: Scalars['Timestamp']['output'];
  id: Scalars['Id']['output'];
  updatedAt: Scalars['Timestamp']['output'];
};

/**
 * ---
 *
 * ## Club entity represents a golf club with metadata.
 * Includes CDC annotations used by downstream tooling.
 */
export type Club = {
  __typename?: 'Club';
  /** Country code (ISO 3166-1 alpha-2). */
  country: Scalars['String']['output'];
  courses: Array<Course>;
  createdAt: Scalars['Timestamp']['output'];
  foundedYear?: Maybe<Scalars['Int']['output']>;
  holes: Array<Hole>;
  id: Scalars['Id']['output'];
  /** Human-friendly club name. */
  name: Scalars['String']['output'];
  players: Array<Player>;
  /** URL-safe slug for the club. */
  slug: Scalars['String']['output'];
  updatedAt: Scalars['Timestamp']['output'];
};

export type ClubBy = {
  id?: InputMaybe<Scalars['ID']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
};

export type ClubConnection = {
  __typename?: 'ClubConnection';
  /** A list of edges. */
  edges: Array<ClubEdge>;
  /** A list of nodes. */
  nodes: Array<Club>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

/** An edge in a connection. */
export type ClubEdge = {
  __typename?: 'ClubEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node: Club;
};

export type ClubFilters = {
  name?: InputMaybe<Scalars['String']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
};

export type Content = HighlightEvent | HighlightMedia;

export enum CoordinateSystem {
  Bd09 = 'BD09',
  Gcj02 = 'GCJ02',
  Wgs84 = 'WGS84',
}

export type Coordinates = {
  __typename?: 'Coordinates';
  latitude: Scalars['Float']['output'];
  longitude: Scalars['Float']['output'];
  system: CoordinateSystem;
};

export type Course = {
  __typename?: 'Course';
  club: Club;
  createdAt: Scalars['Timestamp']['output'];
  holes: Array<CourseHole>;
  id: Scalars['Id']['output'];
  name: Scalars['String']['output'];
  slug: Scalars['String']['output'];
  updatedAt: Scalars['Timestamp']['output'];
};

/**
 * ---
 *
 * ## Junction entity representing the association between courses and holes.
 */
export type CourseHole = {
  __typename?: 'CourseHole';
  annotations: Array<Annotation>;
  clubId?: Maybe<Scalars['Id']['output']>;
  course: Course;
  createdAt: Scalars['Timestamp']['output'];
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['Id']['output'];
  imageUrl?: Maybe<Scalars['String']['output']>;
  /** Hole number within the course. */
  number: Scalars['Int']['output'];
  /** Par for the hole. */
  par: Scalars['Int']['output'];
  /** Stroke index for the hole. */
  strokeIndex: Scalars['Int']['output'];
  tees: Array<TeeBar>;
  updatedAt: Scalars['Timestamp']['output'];
};

export enum Gender {
  Female = 'FEMALE',
  Male = 'MALE',
  Other = 'OTHER',
  Unspecified = 'UNSPECIFIED',
}

export type Highlight = {
  __typename?: 'Highlight';
  content: Content;
  createdAt: Scalars['Timestamp']['output'];
  display: HighlightDisplay;
  duration: Scalars['Int']['output'];
  expirationAt?: Maybe<Scalars['Timestamp']['output']>;
  hole: CourseHole;
  id: Scalars['Id']['output'];
  participation: Participation;
  priority: Scalars['Int']['output'];
  repeat: Scalars['Int']['output'];
  title: Scalars['String']['output'];
};

export enum HighlightDisplay {
  Maximize = 'MAXIMIZE',
  Minimize = 'MINIMIZE',
  Unspecified = 'UNSPECIFIED',
}

export type HighlightEvent = {
  __typename?: 'HighlightEvent';
  type: HighlightEventType;
};

export enum HighlightEventType {
  Albatross = 'ALBATROSS',
  Birdie = 'BIRDIE',
  Bogey = 'BOGEY',
  DoubleBogey = 'DOUBLE_BOGEY',
  Eagle = 'EAGLE',
  HoleInOne = 'HOLE_IN_ONE',
  Par = 'PAR',
  TripleBogey = 'TRIPLE_BOGEY',
  Unspecified = 'UNSPECIFIED',
}

export type HighlightMedia = {
  __typename?: 'HighlightMedia';
  location?: Maybe<LatLng>;
  mimeType: Scalars['String']['output'];
  sizeBytes: Scalars['Int']['output'];
  thumbnailUrl: Scalars['String']['output'];
  url: Scalars['String']['output'];
};

/**
 * ---
 *
 * ## Hole entity represents a single hole on a course.
 */
export type Hole = {
  __typename?: 'Hole';
  annotations: Array<Annotation>;
  courses: Array<Course>;
  createdAt: Scalars['Timestamp']['output'];
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['Id']['output'];
  imageUrl?: Maybe<Scalars['String']['output']>;
  /** Hole number within the course. */
  number: Scalars['Int']['output'];
  /** Par for the hole. */
  par: Scalars['Int']['output'];
  /** Stroke index for the hole. */
  strokeIndex: Scalars['Int']['output'];
  tees: Array<TeeBar>;
  updatedAt: Scalars['Timestamp']['output'];
};

export enum HoleRange {
  Back = 'BACK',
  Front = 'FRONT',
  Full = 'FULL',
  Unspecified = 'UNSPECIFIED',
}

/** The mode or method by which a player registers/inscribes to a tournament. */
export enum InscriptionMode {
  /**
   * (CAL) Calendar-based registration (scheduled/managed via calendar
   * workflow).
   */
  Calendar = 'CALENDAR',
  /** (EML) Registration submitted/managed via email. */
  Email = 'EMAIL',
  /**
   * (OFF) Offline/club-internal inscription (e.g., at the clubhouse, phone,
   * paper form).
   */
  Offline = 'OFFLINE',
  /** (ONL) Online inscription through web/app. */
  Online = 'ONLINE',
  /** (TST) Test/sandbox mode for trials or non-production runs. */
  Test = 'TEST',
  /** (NON) Unspecified/unknown mode. */
  Unspecified = 'UNSPECIFIED',
}

/**
 * An object that represents a latitude/longitude pair. This is expressed as a
 * pair of doubles to represent degrees latitude and degrees longitude. Unless
 * specified otherwise, this must conform to the
 * <a href="<http://www.unoosa.org/pdf/icg/2012/template/WGS_84.pdf">WGS84>
 * standard</a>. Values must be within normalized ranges.
 */
export type LatLng = {
  __typename?: 'LatLng';
  /** The latitude in degrees. It must be in the range \[-90.0, +90.0\]. */
  latitude: Scalars['Float']['output'];
  /** The longitude in degrees. It must be in the range \[-180.0, +180.0\]. */
  longitude: Scalars['Float']['output'];
};

export type LeaderBoard = {
  __typename?: 'LeaderBoard';
  ranking: Array<LeaderBoardRankingEntry>;
  rounds: Array<LeaderBoardRound>;
  tiePolicy?: Maybe<TieBreakPolicy>;
  tournament: Tournament;
};

export type LeaderBoardRankingEntry = {
  __typename?: 'LeaderBoardRankingEntry';
  participation: Participation;
  playedHoles: Scalars['Int']['output'];
  score?: Maybe<ScoreEntry>;
};

export type LeaderBoardRound = {
  __typename?: 'LeaderBoardRound';
  ranking: Array<LeaderBoardRankingEntry>;
  round: Round;
  tiePolicy?: Maybe<TieBreakPolicy>;
};

export type MutationRoot = {
  __typename?: 'MutationRoot';
  createClub: Club;
  createPlayer: Player;
};

export type MutationRootCreateClubArgs = {
  country: Scalars['String']['input'];
  foundedYear: Scalars['Int']['input'];
  name: Scalars['String']['input'];
  slug: Scalars['String']['input'];
};

export type MutationRootCreatePlayerArgs = {
  clubFromDate?: InputMaybe<Scalars['Timestamp']['input']>;
  clubId: Scalars['ID']['input'];
  country?: InputMaybe<Scalars['String']['input']>;
  firstName: Scalars['String']['input'];
  lastName: Scalars['String']['input'];
  license: Scalars['String']['input'];
};

/** Information about pagination in a connection */
export type PageInfo = {
  __typename?: 'PageInfo';
  /** When paginating forwards, the cursor to continue. */
  endCursor?: Maybe<Scalars['String']['output']>;
  /** When paginating forwards, are there more items? */
  hasNextPage: Scalars['Boolean']['output'];
  /** When paginating backwards, are there more items? */
  hasPreviousPage: Scalars['Boolean']['output'];
  /** When paginating backwards, the cursor to continue. */
  startCursor?: Maybe<Scalars['String']['output']>;
};

/**
 * Pagination structure for Relay.
 *
 * This structure defines a standard interface for paginating through
 * resources using cursors. The `after` and `before` fields indicate
 * the boundaries, while `first` and `last` specify how many items to
 * fetch from that boundary.
 *
 * Only one of `first` or `last` should be used at a time. Providing
 * both will result in a validation error.
 *
 * @see <https://relay.dev/graphql/connections.htm#note-95f8a>
 */
export type Pagination = {
  /** Optional cursor after which to return items. */
  after?: InputMaybe<Scalars['Cursor']['input']>;
  /** Optional cursor before which to return items. */
  before?: InputMaybe<Scalars['Cursor']['input']>;
  /** Optional number of items to return after the `after` cursor. */
  first?: InputMaybe<Scalars['Int']['input']>;
  /** Optional number of items to return before the `before` cursor. */
  last?: InputMaybe<Scalars['Int']['input']>;
};

/**
 * A representation of a participant's involvement in a tournament round,
 * which may be individual or collective, and can have hierarchical
 * relationships
 */
export type Participation = {
  __typename?: 'Participation';
  created_at: Scalars['Timestamp']['output'];
  depth: Scalars['Int']['output'];
  id: Scalars['Id']['output'];
  lastScoredHole?: Maybe<CourseHole>;
  parentId?: Maybe<Scalars['Id']['output']>;
  players: Array<Player>;
  round: Round;
  startHole?: Maybe<CourseHole>;
  status: ParticipationStatus;
  teeTime?: Maybe<Scalars['String']['output']>;
  type: ParticipationType;
  updated_at: Scalars['Timestamp']['output'];
};

export enum ParticipationStatus {
  Completed = 'COMPLETED',
  Playing = 'PLAYING',
  Unspecified = 'UNSPECIFIED',
  Waiting = 'WAITING',
}

/** The mode or method by which a team/individual participates in a round. */
export enum ParticipationType {
  /** Collective participation (team, pair, etc.). */
  Collective = 'COLLECTIVE',
  /** Individual participation (single player). */
  Individual = 'INDIVIDUAL',
  /** Unset/unknown type. */
  Unspecified = 'UNSPECIFIED',
}

export enum PlayFormat {
  /**
   * (C) Canada Cup: two-player teams with an aggregate (sum-all)
   * result—typically the team’s total is the sum of the two players’ individual
   * totals (per hole or per round, per event rules).
   */
  CanadaCup = 'CANADA_CUP',
  /**
   * (F) Foursome (Alternate Shot): two-player team plays ONE ball, alternating
   * strokes (and tee shots). A single score is recorded for the pair on each
   * hole.
   */
  Foursome = 'FOURSOME',
  /**
   * (P) Four-Ball (Best Ball of Two): two-player teams; each plays their own
   * ball, and the team score for the hole is the lower of the two individual
   * scores.
   */
  FourBall = 'FOUR_BALL',
  /**
   * (G) Greensome: both partners tee off, the team selects the preferred drive,
   * then plays alternate shots with that single ball until holed. One score per
   * pair.
   */
  Greensome = 'GREENSOME',
  /**
   * (H) Greensome Chapman (Chapman/Pinehurst): both partners tee off, then each
   * plays the partner’s ball for the second shot; one ball is then chosen and
   * the team plays alternate shots into the hole. One score per pair.
   */
  GreensomeChapman = 'GREENSOME_CHAPMAN',
  /**
   * (I) Individual: each player plays their own ball; one individual result is
   * recorded.
   */
  Individual = 'INDIVIDUAL',
  /**
   * (A) Professional–Amateur (Pro-Am): a professional pairs with one or more
   * amateurs. One team result is recorded according to the competition’s
   * scoring basis (e.g., best-ball or aggregate).
   */
  ProfessionalAmateur = 'PROFESSIONAL_AMATEUR',
  /**
   * (S) Scramble: teams of 2–4 players; all tee off, the team selects the best
   * shot, and all play from that spot; repeat until holed. One team score per
   * hole.
   */
  Scramble = 'SCRAMBLE',
  /**
   * (E) Team: multi-player team format where a single team result is recorded
   * (per hole or round), using the competition’s defined method (e.g., best-N,
   * aggregate, or similar).
   */
  Team = 'TEAM',
  /** (N) Unspecified play format. */
  Unspecified = 'UNSPECIFIED',
}

export enum PlayStatus {
  Completed = 'COMPLETED',
  InProgress = 'IN_PROGRESS',
  Scheduled = 'SCHEDULED',
  Suspended = 'SUSPENDED',
  Unspecified = 'UNSPECIFIED',
}

/**
 * ---
 *
 * ## Player entity holds player personal and membership data.
 */
export type Player = {
  __typename?: 'Player';
  club: Club;
  country?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['Timestamp']['output'];
  /** First name. */
  firstName: Scalars['String']['output'];
  id: Scalars['Id']['output'];
  /** Last name. */
  lastName: Scalars['String']['output'];
  /** External license number. */
  license: Scalars['String']['output'];
  status?: Maybe<PlayerStatus>;
  updatedAt: Scalars['Timestamp']['output'];
};

export type PlayerConnection = {
  __typename?: 'PlayerConnection';
  /** A list of edges. */
  edges: Array<PlayerEdge>;
  /** A list of nodes. */
  nodes: Array<Player>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

/** An edge in a connection. */
export type PlayerEdge = {
  __typename?: 'PlayerEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node: Player;
};

export enum PlayerStatus {
  /** The player has finished the game */
  Finished = 'FINISHED',
  /** The player is currently playing */
  Playing = 'PLAYING',
  /** The player is not currently playing */
  Waiting = 'WAITING',
}

export type QueryRoot = {
  __typename?: 'QueryRoot';
  club: Club;
  clubs: ClubConnection;
  course: Course;
  courses: Array<Course>;
  hole: Hole;
  holes: Array<Hole>;
  leaderBoard: LeaderBoard;
  player: Player;
  playerLiveStats: Scalars['String']['output'];
  players: PlayerConnection;
  round: Round;
  rounds: Array<Round>;
  scoreCard: ScoreCard;
  tournament: Tournament;
  tournaments: TournamentConnection;
  weather: Weather;
};

export type QueryRootClubArgs = {
  by: ClubBy;
};

export type QueryRootClubsArgs = {
  filters?: InputMaybe<Array<ClubFilters>>;
  pagination?: InputMaybe<Pagination>;
};

export type QueryRootCourseArgs = {
  id: Scalars['Id']['input'];
};

export type QueryRootCoursesArgs = {
  clubId: Scalars['Id']['input'];
};

export type QueryRootHoleArgs = {
  id: Scalars['Id']['input'];
};

export type QueryRootHolesArgs = {
  holeId: Scalars['Id']['input'];
};

export type QueryRootLeaderBoardArgs = {
  calcMode?: InputMaybe<ScoringCalcMode>;
  tournamentId: Scalars['ID']['input'];
};

export type QueryRootPlayerArgs = {
  id: Scalars['ID']['input'];
};

export type QueryRootPlayerLiveStatsArgs = {
  playerId: Scalars['ID']['input'];
  tournamentId: Scalars['ID']['input'];
};

export type QueryRootPlayersArgs = {
  pagination?: InputMaybe<Pagination>;
};

export type QueryRootRoundArgs = {
  id: Scalars['Id']['input'];
};

export type QueryRootRoundsArgs = {
  tournamentId: Scalars['Id']['input'];
};

export type QueryRootScoreCardArgs = {
  calcMode?: InputMaybe<ScoringCalcMode>;
  participationId: Scalars['ID']['input'];
};

export type QueryRootTournamentArgs = {
  id: Scalars['Id']['input'];
};

export type QueryRootTournamentsArgs = {
  filters?: InputMaybe<Array<TournamentFilters>>;
  pagination?: InputMaybe<Pagination>;
};

export type QueryRootWeatherArgs = {
  latitude: Scalars['Float']['input'];
  longitude: Scalars['Float']['input'];
};

export type Result = ScoreEntry | ScoreSpecial;

export type Round = {
  __typename?: 'Round';
  course: Course;
  createdAt: Scalars['Timestamp']['output'];
  endedAt?: Maybe<Scalars['Timestamp']['output']>;
  holes: HoleRange;
  id: Scalars['Id']['output'];
  ordinal: Scalars['Int']['output'];
  participationDepth: Scalars['Int']['output'];
  participations: Array<Participation>;
  playFormat: PlayFormat;
  startedAt: Scalars['Timestamp']['output'];
  status: PlayStatus;
  tournament: Tournament;
  updatedAt: Scalars['Timestamp']['output'];
};

export enum ScoreAggregationKind {
  /** Take the best N member results per hole (e.g., Four-Ball Best-1). */
  BestN = 'BEST_N',
  /** Scramble formats: team plays from selected best shot each stroke. */
  Scramble = 'SCRAMBLE',
  /** Alternate-shot single-ball formats (Foursome/Greensome family). */
  SingleBallAlternate = 'SINGLE_BALL_ALTERNATE',
  /** Sum every member's hole result (typical team aggregate). */
  SumAll = 'SUM_ALL',
  Unspecified = 'UNSPECIFIED',
}

export type ScoreAggregationPolicy = {
  __typename?: 'ScoreAggregationPolicy';
  kind: ScoreAggregationKind;
  /**
   * For BEST_N (and similar), N indicates how many member scores count.
   * Ignored for other kinds.
   */
  n: Scalars['Int']['output'];
};

export type ScoreCard = {
  __typename?: 'ScoreCard';
  aggregationPolicy?: Maybe<ScoreAggregationPolicy>;
  back?: Maybe<ScoreEntry>;
  front?: Maybe<ScoreEntry>;
  holes: Array<ScoreCardHole>;
  participation: Participation;
  playedHoles: Scalars['Int']['output'];
  round: Round;
  total?: Maybe<ScoreEntry>;
  totalHoles: Scalars['Int']['output'];
  tournament: Tournament;
};

export type ScoreCardHole = {
  __typename?: 'ScoreCardHole';
  createdAt?: Maybe<Scalars['Timestamp']['output']>;
  handicap: Scalars['Int']['output'];
  holeNumber: Scalars['Int']['output'];
  par: Scalars['Int']['output'];
  result: Result;
  updatedAt?: Maybe<Scalars['Timestamp']['output']>;
};

export type ScoreEntry = {
  __typename?: 'ScoreEntry';
  stableford?: Maybe<Scalars['Int']['output']>;
  strokes: Scalars['Int']['output'];
  toPar: Scalars['Int']['output'];
};

export enum ScoreField {
  Stableford = 'STABLEFORD',
  Strokes = 'STROKES',
  ToPar = 'TO_PAR',
  Unspecified = 'UNSPECIFIED',
}

export type ScoreSpecial = {
  __typename?: 'ScoreSpecial';
  kind: ScoreSpecialKind;
  notes: Scalars['String']['output'];
};

export enum ScoreSpecialKind {
  ScoreSpecialPickedUp = 'SCORE_SPECIAL_PICKED_UP',
  ScoreSpecialUnspecified = 'SCORE_SPECIAL_UNSPECIFIED',
}

export enum ScoringCalcMode {
  Handicap = 'HANDICAP',
  Scratch = 'SCRATCH',
  Unspecified = 'UNSPECIFIED',
}

export enum ScoringSystem {
  /**
   * (P) Match Play — holes are scored individually; a hole is won by taking
   * fewer strokes, halved if tied. The match ends when a lead exceeds the
   * number of holes remaining (e.g., “dormie” when lead equals holes left).
   */
  MatchPlay = 'MATCH_PLAY',
  /**
   * (M) Medal Play — total strokes across the entire round are counted; the
   * lowest aggregate wins.
   */
  MedalPlay = 'MEDAL_PLAY',
  /**
   * (S) Stableford — players earn points per hole based on score relative to
   * par, typically adjusted by handicap; higher points total wins.
   */
  Stableford = 'STABLEFORD',
  /**
   * (C) Stroke Play — winner is the player with the fewest total strokes taken
   * to complete the course.
   */
  StrokePlay = 'STROKE_PLAY',
  /** Unset/unknown mode. */
  Unspecified = 'UNSPECIFIED',
}

export enum Sorting {
  Asc = 'ASC',
  Desc = 'DESC',
}

export type SubscribePlayerGeopositionResponse = {
  __typename?: 'SubscribePlayerGeopositionResponse';
  coordinates: Coordinates;
  player: Player;
  timestamp: Scalars['Timestamp']['output'];
};

export type SubscriptionRoot = {
  __typename?: 'SubscriptionRoot';
  highlight: Highlight;
  playerTracking: SubscribePlayerGeopositionResponse;
};

export type SubscriptionRootHighlightArgs = {
  tournamentId: Scalars['Id']['input'];
};

export type SubscriptionRootPlayerTrackingArgs = {
  playerId: Scalars['ID']['input'];
};

export type TeeBar = {
  __typename?: 'TeeBar';
  color: TeeColor;
  createdAt: Scalars['Timestamp']['output'];
  gender: Gender;
  length?: Maybe<Scalars['Int']['output']>;
  pace?: Maybe<Scalars['Int']['output']>;
  /**
   * Stroke index (1-18) for this tee bar on the hole,
   * which indicates the relative difficulty of the hole,
   */
  strokeIndex: Scalars['Int']['output'];
  updatedAt: Scalars['Timestamp']['output'];
};

export enum TeeColor {
  Black = 'BLACK',
  Blue = 'BLUE',
  Golden = 'GOLDEN',
  Green = 'GREEN',
  Orange = 'ORANGE',
  Pink = 'PINK',
  Red = 'RED',
  Unspecified = 'UNSPECIFIED',
  White = 'WHITE',
  Yellow = 'YELLOW',
}

export enum TieBreakKind {
  /** Compare hole-by-hole from 18 backwards using the given field. */
  HoleByHoleBack = 'HOLE_BY_HOLE_BACK',
  /** Use player/team attribute (e.g., lowest playing handicap wins). */
  LowestHandicap = 'LOWEST_HANDICAP',
  /** Sum the given field over the last N holes (e.g., 18, 9, 6, 3, 1). */
  SumLastNHoles = 'SUM_LAST_N_HOLES',
  Unspecified = 'UNSPECIFIED',
}

export type TieBreakPolicy = {
  __typename?: 'TieBreakPolicy';
  steps: Array<TieBreakSpec>;
};

export type TieBreakSpec = {
  __typename?: 'TieBreakSpec';
  direction: Sorting;
  field: ScoreField;
  kind: TieBreakKind;
  /** used by SUM_LAST_N_HOLES */
  lastNHoles: Scalars['Int']['output'];
  note?: Maybe<Scalars['String']['output']>;
};

export type Tournament = {
  __typename?: 'Tournament';
  capacity: Scalars['Int']['output'];
  createdAt: Scalars['Timestamp']['output'];
  host: Club;
  id: Scalars['Id']['output'];
  inscriptionMode: InscriptionMode;
  name: Scalars['String']['output'];
  organizer: Club;
  players: Scalars['Int']['output'];
  rounds: Array<Round>;
  scoringSystem: ScoringSystem;
  status: PlayStatus;
  updatedAt: Scalars['Timestamp']['output'];
};

export type TournamentConnection = {
  __typename?: 'TournamentConnection';
  /** A list of edges. */
  edges: Array<TournamentEdge>;
  /** A list of nodes. */
  nodes: Array<Tournament>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

/** An edge in a connection. */
export type TournamentEdge = {
  __typename?: 'TournamentEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node: Tournament;
};

export type TournamentFilters = {
  name?: InputMaybe<Scalars['String']['input']>;
  statuses?: InputMaybe<Array<PlayStatus>>;
};

export type Weather = {
  __typename?: 'Weather';
  condition: Scalars['String']['output'];
  humidityPercent: Scalars['Int']['output'];
  observedAt?: Maybe<Scalars['Timestamp']['output']>;
  precipitationMm: Scalars['Float']['output'];
  pressureHpa: Scalars['Float']['output'];
  temperature?: Maybe<WeatherTemperature>;
  temperatureRange?: Maybe<WeatherTemperatureRange>;
  wind?: Maybe<WeatherWind>;
};

export type WeatherTemperature = {
  __typename?: 'WeatherTemperature';
  celsius: Scalars['Float']['output'];
  fahrenheit: Scalars['Float']['output'];
};

export type WeatherTemperatureRange = {
  __typename?: 'WeatherTemperatureRange';
  avgCelsius: Scalars['Float']['output'];
  maxCelsius: Scalars['Float']['output'];
  minCelsius: Scalars['Float']['output'];
};

export type WeatherWind = {
  __typename?: 'WeatherWind';
  directionCardinal: Scalars['String']['output'];
  directionDegrees: Scalars['Int']['output'];
  speedKph: Scalars['Float']['output'];
  speedMph: Scalars['Float']['output'];
  speedMs: Scalars['Float']['output'];
};

export type ClubFieldsFragment = {
  __typename?: 'Club';
  id: string;
  name: string;
  slug: string;
  country: string;
  createdAt: string;
  updatedAt: string;
};

export type CourseFieldsFragment = {
  __typename?: 'Course';
  id: string;
  name: string;
  slug: string;
  createdAt: string;
  updatedAt: string;
};

export type CourseHoleFieldsFragment = {
  __typename?: 'CourseHole';
  id: string;
  number: number;
  par: number;
  strokeIndex: number;
  imageUrl?: string | null;
  description?: string | null;
  createdAt: string;
  updatedAt: string;
};

export type HighlightFieldsFragment = {
  __typename?: 'Highlight';
  id: string;
  title: string;
  duration: number;
  priority: number;
  repeat: number;
  createdAt: string;
  display: HighlightDisplay;
  expirationAt?: string | null;
  participation: {
    __typename?: 'Participation';
    id: string;
    type: ParticipationType;
    status: ParticipationStatus;
    teeTime?: string | null;
  };
};

export type HoleFieldsFragment = {
  __typename?: 'Hole';
  id: string;
  number: number;
  par: number;
  strokeIndex: number;
  imageUrl?: string | null;
  description?: string | null;
  createdAt: string;
  updatedAt: string;
};

export type PageInfoFieldsFragment = {
  __typename?: 'PageInfo';
  endCursor?: string | null;
  startCursor?: string | null;
  hasNextPage: boolean;
  hasPreviousPage: boolean;
};

export type ParticipationFieldsFragment = {
  __typename?: 'Participation';
  id: string;
  type: ParticipationType;
  status: ParticipationStatus;
  teeTime?: string | null;
};

export type PlayerFieldsFragment = {
  __typename?: 'Player';
  id: string;
  firstName: string;
  lastName: string;
  license: string;
  status?: PlayerStatus | null;
};

export type RoundFieldsFragment = {
  __typename?: 'Round';
  id: string;
  ordinal: number;
  course: {
    __typename?: 'Course';
    id: string;
    name: string;
    slug: string;
    createdAt: string;
    updatedAt: string;
  };
};

export type ScoreCardFieldsFragment = {
  __typename?: 'ScoreCard';
  totalHoles: number;
  front?: {
    __typename?: 'ScoreEntry';
    stableford?: number | null;
    strokes: number;
    toPar: number;
  } | null;
  back?: {
    __typename?: 'ScoreEntry';
    stableford?: number | null;
    strokes: number;
    toPar: number;
  } | null;
  total?: {
    __typename?: 'ScoreEntry';
    stableford?: number | null;
    strokes: number;
    toPar: number;
  } | null;
};

export type ScoreCardHoleFieldsFragment = {
  __typename?: 'ScoreCardHole';
  holeNumber: number;
  par: number;
  updatedAt?: string | null;
  result:
    | { __typename?: 'ScoreEntry'; strokes: number; toPar: number; stableford?: number | null }
    | { __typename?: 'ScoreSpecial'; kind: ScoreSpecialKind; notes: string };
};

export type TeeFieldsFragment = {
  __typename?: 'TeeBar';
  length?: number | null;
  gender: Gender;
  color: TeeColor;
  pace?: number | null;
  strokeIndex: number;
  updatedAt: string;
};

export type TournamentFieldsFragment = { __typename?: 'Tournament'; id: string; name: string };

export type GetClubQueryVariables = Exact<{
  by: ClubBy;
}>;

export type GetClubQuery = {
  __typename?: 'QueryRoot';
  club: {
    __typename?: 'Club';
    id: string;
    name: string;
    slug: string;
    country: string;
    createdAt: string;
    updatedAt: string;
    holes: Array<{
      __typename?: 'Hole';
      id: string;
      number: number;
      par: number;
      strokeIndex: number;
      imageUrl?: string | null;
      description?: string | null;
      createdAt: string;
      updatedAt: string;
      tees: Array<{
        __typename?: 'TeeBar';
        length?: number | null;
        gender: Gender;
        color: TeeColor;
        pace?: number | null;
        strokeIndex: number;
        updatedAt: string;
      }>;
    }>;
  };
};

export type GetClubsQueryVariables = Exact<{
  filters?: InputMaybe<Array<ClubFilters> | ClubFilters>;
  pagination?: InputMaybe<Pagination>;
}>;

export type GetClubsQuery = {
  __typename?: 'QueryRoot';
  clubs: {
    __typename?: 'ClubConnection';
    nodes: Array<{
      __typename?: 'Club';
      id: string;
      name: string;
      slug: string;
      country: string;
      createdAt: string;
      updatedAt: string;
    }>;
    pageInfo: {
      __typename?: 'PageInfo';
      hasNextPage: boolean;
      hasPreviousPage: boolean;
      startCursor?: string | null;
      endCursor?: string | null;
    };
    edges: Array<{
      __typename?: 'ClubEdge';
      cursor: string;
      node: {
        __typename?: 'Club';
        id: string;
        name: string;
        slug: string;
        country: string;
        createdAt: string;
        updatedAt: string;
      };
    }>;
  };
};

export type GetCourseQueryVariables = Exact<{
  id: Scalars['Id']['input'];
}>;

export type GetCourseQuery = {
  __typename?: 'QueryRoot';
  course: {
    __typename?: 'Course';
    id: string;
    name: string;
    slug: string;
    createdAt: string;
    updatedAt: string;
  };
};

export type GetHoleQueryVariables = Exact<{
  id: Scalars['Id']['input'];
}>;

export type GetHoleQuery = {
  __typename?: 'QueryRoot';
  hole: {
    __typename?: 'Hole';
    id: string;
    number: number;
    par: number;
    strokeIndex: number;
    imageUrl?: string | null;
    description?: string | null;
    createdAt: string;
    updatedAt: string;
  };
};

export type GetLeaderBoardQueryVariables = Exact<{
  tournamentId: Scalars['ID']['input'];
  calcMode?: InputMaybe<ScoringCalcMode>;
}>;

export type GetLeaderBoardQuery = {
  __typename?: 'QueryRoot';
  leaderBoard: {
    __typename?: 'LeaderBoard';
    tournament: { __typename?: 'Tournament'; id: string; name: string };
    rounds: Array<{
      __typename?: 'LeaderBoardRound';
      round: {
        __typename?: 'Round';
        id: string;
        ordinal: number;
        playFormat: PlayFormat;
        status: PlayStatus;
      };
      ranking: Array<{
        __typename?: 'LeaderBoardRankingEntry';
        playedHoles: number;
        participation: {
          __typename?: 'Participation';
          id: string;
          type: ParticipationType;
          players: Array<{
            __typename?: 'Player';
            id: string;
            firstName: string;
            lastName: string;
            license: string;
          }>;
        };
        score?: {
          __typename?: 'ScoreEntry';
          stableford?: number | null;
          strokes: number;
          toPar: number;
        } | null;
      }>;
    }>;
    ranking: Array<{
      __typename?: 'LeaderBoardRankingEntry';
      playedHoles: number;
      participation: {
        __typename?: 'Participation';
        id: string;
        type: ParticipationType;
        status: ParticipationStatus;
        teeTime?: string | null;
        startHole?: {
          __typename?: 'CourseHole';
          id: string;
          number: number;
          par: number;
          strokeIndex: number;
          imageUrl?: string | null;
          description?: string | null;
          createdAt: string;
          updatedAt: string;
        } | null;
        lastScoredHole?: {
          __typename?: 'CourseHole';
          id: string;
          number: number;
          par: number;
          strokeIndex: number;
          imageUrl?: string | null;
          description?: string | null;
          createdAt: string;
          updatedAt: string;
        } | null;
        players: Array<{
          __typename?: 'Player';
          id: string;
          firstName: string;
          lastName: string;
          license: string;
          status?: PlayerStatus | null;
        }>;
      };
      score?: {
        __typename?: 'ScoreEntry';
        stableford?: number | null;
        strokes: number;
        toPar: number;
      } | null;
    }>;
    tiePolicy?: {
      __typename?: 'TieBreakPolicy';
      steps: Array<{
        __typename?: 'TieBreakSpec';
        lastNHoles: number;
        kind: TieBreakKind;
        field: ScoreField;
        direction: Sorting;
        note?: string | null;
      }>;
    } | null;
  };
};

export type GetScoreCardQueryVariables = Exact<{
  participationId: Scalars['ID']['input'];
}>;

export type GetScoreCardQuery = {
  __typename?: 'QueryRoot';
  scoreCard: {
    __typename?: 'ScoreCard';
    totalHoles: number;
    holes: Array<{
      __typename?: 'ScoreCardHole';
      holeNumber: number;
      par: number;
      updatedAt?: string | null;
      result:
        | { __typename?: 'ScoreEntry'; strokes: number; toPar: number; stableford?: number | null }
        | { __typename?: 'ScoreSpecial'; kind: ScoreSpecialKind; notes: string };
    }>;
    front?: {
      __typename?: 'ScoreEntry';
      stableford?: number | null;
      strokes: number;
      toPar: number;
    } | null;
    back?: {
      __typename?: 'ScoreEntry';
      stableford?: number | null;
      strokes: number;
      toPar: number;
    } | null;
    total?: {
      __typename?: 'ScoreEntry';
      stableford?: number | null;
      strokes: number;
      toPar: number;
    } | null;
  };
};

export type GetTournamentQueryVariables = Exact<{
  id: Scalars['Id']['input'];
}>;

export type GetTournamentQuery = {
  __typename?: 'QueryRoot';
  tournament: {
    __typename?: 'Tournament';
    id: string;
    name: string;
    host: {
      __typename?: 'Club';
      id: string;
      name: string;
      slug: string;
      country: string;
      createdAt: string;
      updatedAt: string;
    };
    organizer: {
      __typename?: 'Club';
      id: string;
      name: string;
      slug: string;
      country: string;
      createdAt: string;
      updatedAt: string;
    };
  };
};

export type GetTournamentsQueryVariables = Exact<{
  filters?: InputMaybe<Array<TournamentFilters> | TournamentFilters>;
  pagination?: InputMaybe<Pagination>;
}>;

export type GetTournamentsQuery = {
  __typename?: 'QueryRoot';
  tournaments: {
    __typename?: 'TournamentConnection';
    nodes: Array<{
      __typename?: 'Tournament';
      id: string;
      name: string;
      host: {
        __typename?: 'Club';
        id: string;
        name: string;
        slug: string;
        country: string;
        createdAt: string;
        updatedAt: string;
      };
      organizer: {
        __typename?: 'Club';
        id: string;
        name: string;
        slug: string;
        country: string;
        createdAt: string;
        updatedAt: string;
      };
    }>;
    pageInfo: {
      __typename?: 'PageInfo';
      endCursor?: string | null;
      startCursor?: string | null;
      hasNextPage: boolean;
      hasPreviousPage: boolean;
    };
  };
};

export type GetWeatherQueryVariables = Exact<{
  latitude: Scalars['Float']['input'];
  longitude: Scalars['Float']['input'];
}>;

export type GetWeatherQuery = {
  __typename?: 'QueryRoot';
  weather: {
    __typename?: 'Weather';
    temperatureRange?: {
      __typename?: 'WeatherTemperatureRange';
      avgCelsius: number;
      maxCelsius: number;
      minCelsius: number;
    } | null;
    wind?: {
      __typename?: 'WeatherWind';
      speedKph: number;
      directionCardinal: string;
      directionDegrees: number;
    } | null;
  };
};

export type SubscribeHighlightsSubscriptionVariables = Exact<{
  tournamentId: Scalars['Id']['input'];
}>;

export type SubscribeHighlightsSubscription = {
  __typename?: 'SubscriptionRoot';
  highlight: {
    __typename?: 'Highlight';
    id: string;
    title: string;
    duration: number;
    priority: number;
    repeat: number;
    createdAt: string;
    display: HighlightDisplay;
    expirationAt?: string | null;
    hole: {
      __typename?: 'CourseHole';
      id: string;
      number: number;
      par: number;
      strokeIndex: number;
      imageUrl?: string | null;
      description?: string | null;
      createdAt: string;
      updatedAt: string;
    };
    participation: {
      __typename?: 'Participation';
      id: string;
      type: ParticipationType;
      status: ParticipationStatus;
      teeTime?: string | null;
      players: Array<{
        __typename?: 'Player';
        id: string;
        firstName: string;
        lastName: string;
        license: string;
        status?: PlayerStatus | null;
      }>;
    };
  };
};

export const ClubFieldsFragmentDoc = gql`
  fragment ClubFields on Club {
    id
    name
    slug
    country
    createdAt
    updatedAt
  }
`;
export const CourseHoleFieldsFragmentDoc = gql`
  fragment CourseHoleFields on CourseHole {
    id
    number
    par
    strokeIndex
    imageUrl
    description
    createdAt
    updatedAt
  }
`;
export const ParticipationFieldsFragmentDoc = gql`
  fragment ParticipationFields on Participation {
    id
    type
    status
    teeTime
  }
`;
export const HighlightFieldsFragmentDoc = gql`
  fragment HighlightFields on Highlight {
    id
    title
    duration
    priority
    repeat
    createdAt
    display
    expirationAt
    participation {
      ...ParticipationFields
    }
  }
  ${ParticipationFieldsFragmentDoc}
`;
export const HoleFieldsFragmentDoc = gql`
  fragment HoleFields on Hole {
    id
    number
    par
    strokeIndex
    imageUrl
    description
    createdAt
    updatedAt
  }
`;
export const PageInfoFieldsFragmentDoc = gql`
  fragment PageInfoFields on PageInfo {
    endCursor
    startCursor
    hasNextPage
    hasPreviousPage
  }
`;
export const PlayerFieldsFragmentDoc = gql`
  fragment PlayerFields on Player {
    id
    firstName
    lastName
    license
    status
  }
`;
export const CourseFieldsFragmentDoc = gql`
  fragment CourseFields on Course {
    id
    name
    slug
    createdAt
    updatedAt
  }
`;
export const RoundFieldsFragmentDoc = gql`
  fragment RoundFields on Round {
    id
    ordinal
    course {
      ...CourseFields
    }
  }
  ${CourseFieldsFragmentDoc}
`;
export const ScoreCardFieldsFragmentDoc = gql`
  fragment ScoreCardFields on ScoreCard {
    front {
      stableford
      strokes
      toPar
    }
    back {
      stableford
      strokes
      toPar
    }
    total {
      stableford
      strokes
      toPar
    }
    totalHoles
  }
`;
export const ScoreCardHoleFieldsFragmentDoc = gql`
  fragment ScoreCardHoleFields on ScoreCardHole {
    holeNumber
    par
    result {
      ... on ScoreEntry {
        strokes
        toPar
        stableford
      }
      ... on ScoreSpecial {
        kind
        notes
      }
    }
    updatedAt
  }
`;
export const TeeFieldsFragmentDoc = gql`
  fragment TeeFields on TeeBar {
    length
    gender
    color
    pace
    strokeIndex
    updatedAt
  }
`;
export const TournamentFieldsFragmentDoc = gql`
  fragment TournamentFields on Tournament {
    id
    name
  }
`;
export const GetClubDocument = gql`
  query GetClub($by: ClubBy!) {
    club(by: $by) {
      ...ClubFields
      holes {
        ...HoleFields
        tees {
          ...TeeFields
        }
      }
    }
  }
  ${ClubFieldsFragmentDoc}
  ${HoleFieldsFragmentDoc}
  ${TeeFieldsFragmentDoc}
`;

/**
 * __useGetClubQuery__
 *
 * To run a query within a React component, call `useGetClubQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetClubQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetClubQuery({
 *   variables: {
 *      by: // value for 'by'
 *   },
 * });
 */
export function useGetClubQuery(
  baseOptions: Apollo.QueryHookOptions<GetClubQuery, GetClubQueryVariables> &
    ({ variables: GetClubQueryVariables; skip?: boolean } | { skip: boolean }),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetClubQuery, GetClubQueryVariables>(GetClubDocument, options);
}
export function useGetClubLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<GetClubQuery, GetClubQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetClubQuery, GetClubQueryVariables>(GetClubDocument, options);
}
export function useGetClubSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<GetClubQuery, GetClubQueryVariables>,
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<GetClubQuery, GetClubQueryVariables>(GetClubDocument, options);
}
export type GetClubQueryHookResult = ReturnType<typeof useGetClubQuery>;
export type GetClubLazyQueryHookResult = ReturnType<typeof useGetClubLazyQuery>;
export type GetClubSuspenseQueryHookResult = ReturnType<typeof useGetClubSuspenseQuery>;
export type GetClubQueryResult = Apollo.QueryResult<GetClubQuery, GetClubQueryVariables>;
export const GetClubsDocument = gql`
  query GetClubs($filters: [ClubFilters!], $pagination: Pagination) {
    clubs(pagination: $pagination, filters: $filters) {
      nodes {
        ...ClubFields
      }
      pageInfo {
        hasNextPage
        hasPreviousPage
        startCursor
        endCursor
      }
      edges {
        cursor
        node {
          ...ClubFields
        }
      }
    }
  }
  ${ClubFieldsFragmentDoc}
`;

/**
 * __useGetClubsQuery__
 *
 * To run a query within a React component, call `useGetClubsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetClubsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetClubsQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      pagination: // value for 'pagination'
 *   },
 * });
 */
export function useGetClubsQuery(
  baseOptions?: Apollo.QueryHookOptions<GetClubsQuery, GetClubsQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetClubsQuery, GetClubsQueryVariables>(GetClubsDocument, options);
}
export function useGetClubsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<GetClubsQuery, GetClubsQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetClubsQuery, GetClubsQueryVariables>(GetClubsDocument, options);
}
export function useGetClubsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<GetClubsQuery, GetClubsQueryVariables>,
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<GetClubsQuery, GetClubsQueryVariables>(GetClubsDocument, options);
}
export type GetClubsQueryHookResult = ReturnType<typeof useGetClubsQuery>;
export type GetClubsLazyQueryHookResult = ReturnType<typeof useGetClubsLazyQuery>;
export type GetClubsSuspenseQueryHookResult = ReturnType<typeof useGetClubsSuspenseQuery>;
export type GetClubsQueryResult = Apollo.QueryResult<GetClubsQuery, GetClubsQueryVariables>;
export const GetCourseDocument = gql`
  query GetCourse($id: Id!) {
    course(id: $id) {
      ...CourseFields
    }
  }
  ${CourseFieldsFragmentDoc}
`;

/**
 * __useGetCourseQuery__
 *
 * To run a query within a React component, call `useGetCourseQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCourseQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCourseQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetCourseQuery(
  baseOptions: Apollo.QueryHookOptions<GetCourseQuery, GetCourseQueryVariables> &
    ({ variables: GetCourseQueryVariables; skip?: boolean } | { skip: boolean }),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetCourseQuery, GetCourseQueryVariables>(GetCourseDocument, options);
}
export function useGetCourseLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<GetCourseQuery, GetCourseQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetCourseQuery, GetCourseQueryVariables>(GetCourseDocument, options);
}
export function useGetCourseSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<GetCourseQuery, GetCourseQueryVariables>,
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<GetCourseQuery, GetCourseQueryVariables>(
    GetCourseDocument,
    options,
  );
}
export type GetCourseQueryHookResult = ReturnType<typeof useGetCourseQuery>;
export type GetCourseLazyQueryHookResult = ReturnType<typeof useGetCourseLazyQuery>;
export type GetCourseSuspenseQueryHookResult = ReturnType<typeof useGetCourseSuspenseQuery>;
export type GetCourseQueryResult = Apollo.QueryResult<GetCourseQuery, GetCourseQueryVariables>;
export const GetHoleDocument = gql`
  query GetHole($id: Id!) {
    hole(id: $id) {
      ...HoleFields
    }
  }
  ${HoleFieldsFragmentDoc}
`;

/**
 * __useGetHoleQuery__
 *
 * To run a query within a React component, call `useGetHoleQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetHoleQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetHoleQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetHoleQuery(
  baseOptions: Apollo.QueryHookOptions<GetHoleQuery, GetHoleQueryVariables> &
    ({ variables: GetHoleQueryVariables; skip?: boolean } | { skip: boolean }),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetHoleQuery, GetHoleQueryVariables>(GetHoleDocument, options);
}
export function useGetHoleLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<GetHoleQuery, GetHoleQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetHoleQuery, GetHoleQueryVariables>(GetHoleDocument, options);
}
export function useGetHoleSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<GetHoleQuery, GetHoleQueryVariables>,
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<GetHoleQuery, GetHoleQueryVariables>(GetHoleDocument, options);
}
export type GetHoleQueryHookResult = ReturnType<typeof useGetHoleQuery>;
export type GetHoleLazyQueryHookResult = ReturnType<typeof useGetHoleLazyQuery>;
export type GetHoleSuspenseQueryHookResult = ReturnType<typeof useGetHoleSuspenseQuery>;
export type GetHoleQueryResult = Apollo.QueryResult<GetHoleQuery, GetHoleQueryVariables>;
export const GetLeaderBoardDocument = gql`
  query GetLeaderBoard($tournamentId: ID!, $calcMode: ScoringCalcMode) {
    leaderBoard(tournamentId: $tournamentId, calcMode: $calcMode) {
      tournament {
        ...TournamentFields
      }
      rounds {
        round {
          id
          ordinal
          playFormat
          status
        }
        ranking {
          playedHoles
          participation {
            id
            type
            players {
              id
              firstName
              lastName
              license
            }
          }
          score {
            stableford
            strokes
            toPar
          }
        }
      }
      ranking {
        playedHoles
        participation {
          ...ParticipationFields
          startHole {
            ...CourseHoleFields
          }
          lastScoredHole {
            ...CourseHoleFields
          }
          players {
            ...PlayerFields
          }
        }
        score {
          stableford
          strokes
          toPar
        }
      }
      tiePolicy {
        steps {
          lastNHoles
          kind
          field
          direction
          note
        }
      }
    }
  }
  ${TournamentFieldsFragmentDoc}
  ${ParticipationFieldsFragmentDoc}
  ${CourseHoleFieldsFragmentDoc}
  ${PlayerFieldsFragmentDoc}
`;

/**
 * __useGetLeaderBoardQuery__
 *
 * To run a query within a React component, call `useGetLeaderBoardQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetLeaderBoardQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetLeaderBoardQuery({
 *   variables: {
 *      tournamentId: // value for 'tournamentId'
 *      calcMode: // value for 'calcMode'
 *   },
 * });
 */
export function useGetLeaderBoardQuery(
  baseOptions: Apollo.QueryHookOptions<GetLeaderBoardQuery, GetLeaderBoardQueryVariables> &
    ({ variables: GetLeaderBoardQueryVariables; skip?: boolean } | { skip: boolean }),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetLeaderBoardQuery, GetLeaderBoardQueryVariables>(
    GetLeaderBoardDocument,
    options,
  );
}
export function useGetLeaderBoardLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<GetLeaderBoardQuery, GetLeaderBoardQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetLeaderBoardQuery, GetLeaderBoardQueryVariables>(
    GetLeaderBoardDocument,
    options,
  );
}
export function useGetLeaderBoardSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<GetLeaderBoardQuery, GetLeaderBoardQueryVariables>,
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<GetLeaderBoardQuery, GetLeaderBoardQueryVariables>(
    GetLeaderBoardDocument,
    options,
  );
}
export type GetLeaderBoardQueryHookResult = ReturnType<typeof useGetLeaderBoardQuery>;
export type GetLeaderBoardLazyQueryHookResult = ReturnType<typeof useGetLeaderBoardLazyQuery>;
export type GetLeaderBoardSuspenseQueryHookResult = ReturnType<
  typeof useGetLeaderBoardSuspenseQuery
>;
export type GetLeaderBoardQueryResult = Apollo.QueryResult<
  GetLeaderBoardQuery,
  GetLeaderBoardQueryVariables
>;
export const GetScoreCardDocument = gql`
  query GetScoreCard($participationId: ID!) {
    scoreCard(participationId: $participationId) {
      ...ScoreCardFields
      holes {
        ...ScoreCardHoleFields
      }
    }
  }
  ${ScoreCardFieldsFragmentDoc}
  ${ScoreCardHoleFieldsFragmentDoc}
`;

/**
 * __useGetScoreCardQuery__
 *
 * To run a query within a React component, call `useGetScoreCardQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetScoreCardQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetScoreCardQuery({
 *   variables: {
 *      participationId: // value for 'participationId'
 *   },
 * });
 */
export function useGetScoreCardQuery(
  baseOptions: Apollo.QueryHookOptions<GetScoreCardQuery, GetScoreCardQueryVariables> &
    ({ variables: GetScoreCardQueryVariables; skip?: boolean } | { skip: boolean }),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetScoreCardQuery, GetScoreCardQueryVariables>(
    GetScoreCardDocument,
    options,
  );
}
export function useGetScoreCardLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<GetScoreCardQuery, GetScoreCardQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetScoreCardQuery, GetScoreCardQueryVariables>(
    GetScoreCardDocument,
    options,
  );
}
export function useGetScoreCardSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<GetScoreCardQuery, GetScoreCardQueryVariables>,
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<GetScoreCardQuery, GetScoreCardQueryVariables>(
    GetScoreCardDocument,
    options,
  );
}
export type GetScoreCardQueryHookResult = ReturnType<typeof useGetScoreCardQuery>;
export type GetScoreCardLazyQueryHookResult = ReturnType<typeof useGetScoreCardLazyQuery>;
export type GetScoreCardSuspenseQueryHookResult = ReturnType<typeof useGetScoreCardSuspenseQuery>;
export type GetScoreCardQueryResult = Apollo.QueryResult<
  GetScoreCardQuery,
  GetScoreCardQueryVariables
>;
export const GetTournamentDocument = gql`
  query GetTournament($id: Id!) {
    tournament(id: $id) {
      ...TournamentFields
      host {
        ...ClubFields
      }
      organizer {
        ...ClubFields
      }
    }
  }
  ${TournamentFieldsFragmentDoc}
  ${ClubFieldsFragmentDoc}
`;

/**
 * __useGetTournamentQuery__
 *
 * To run a query within a React component, call `useGetTournamentQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTournamentQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTournamentQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetTournamentQuery(
  baseOptions: Apollo.QueryHookOptions<GetTournamentQuery, GetTournamentQueryVariables> &
    ({ variables: GetTournamentQueryVariables; skip?: boolean } | { skip: boolean }),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetTournamentQuery, GetTournamentQueryVariables>(
    GetTournamentDocument,
    options,
  );
}
export function useGetTournamentLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<GetTournamentQuery, GetTournamentQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetTournamentQuery, GetTournamentQueryVariables>(
    GetTournamentDocument,
    options,
  );
}
export function useGetTournamentSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<GetTournamentQuery, GetTournamentQueryVariables>,
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<GetTournamentQuery, GetTournamentQueryVariables>(
    GetTournamentDocument,
    options,
  );
}
export type GetTournamentQueryHookResult = ReturnType<typeof useGetTournamentQuery>;
export type GetTournamentLazyQueryHookResult = ReturnType<typeof useGetTournamentLazyQuery>;
export type GetTournamentSuspenseQueryHookResult = ReturnType<typeof useGetTournamentSuspenseQuery>;
export type GetTournamentQueryResult = Apollo.QueryResult<
  GetTournamentQuery,
  GetTournamentQueryVariables
>;
export const GetTournamentsDocument = gql`
  query GetTournaments($filters: [TournamentFilters!], $pagination: Pagination) {
    tournaments(filters: $filters, pagination: $pagination) {
      nodes {
        ...TournamentFields
        host {
          ...ClubFields
        }
        organizer {
          ...ClubFields
        }
      }
      pageInfo {
        ...PageInfoFields
      }
    }
  }
  ${TournamentFieldsFragmentDoc}
  ${ClubFieldsFragmentDoc}
  ${PageInfoFieldsFragmentDoc}
`;

/**
 * __useGetTournamentsQuery__
 *
 * To run a query within a React component, call `useGetTournamentsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTournamentsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTournamentsQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      pagination: // value for 'pagination'
 *   },
 * });
 */
export function useGetTournamentsQuery(
  baseOptions?: Apollo.QueryHookOptions<GetTournamentsQuery, GetTournamentsQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetTournamentsQuery, GetTournamentsQueryVariables>(
    GetTournamentsDocument,
    options,
  );
}
export function useGetTournamentsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<GetTournamentsQuery, GetTournamentsQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetTournamentsQuery, GetTournamentsQueryVariables>(
    GetTournamentsDocument,
    options,
  );
}
export function useGetTournamentsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<GetTournamentsQuery, GetTournamentsQueryVariables>,
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<GetTournamentsQuery, GetTournamentsQueryVariables>(
    GetTournamentsDocument,
    options,
  );
}
export type GetTournamentsQueryHookResult = ReturnType<typeof useGetTournamentsQuery>;
export type GetTournamentsLazyQueryHookResult = ReturnType<typeof useGetTournamentsLazyQuery>;
export type GetTournamentsSuspenseQueryHookResult = ReturnType<
  typeof useGetTournamentsSuspenseQuery
>;
export type GetTournamentsQueryResult = Apollo.QueryResult<
  GetTournamentsQuery,
  GetTournamentsQueryVariables
>;
export const GetWeatherDocument = gql`
  query GetWeather($latitude: Float!, $longitude: Float!) {
    weather(latitude: $latitude, longitude: $longitude) {
      temperatureRange {
        avgCelsius
        maxCelsius
        minCelsius
      }
      wind {
        speedKph
        directionCardinal
        directionDegrees
      }
    }
  }
`;

/**
 * __useGetWeatherQuery__
 *
 * To run a query within a React component, call `useGetWeatherQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetWeatherQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetWeatherQuery({
 *   variables: {
 *      latitude: // value for 'latitude'
 *      longitude: // value for 'longitude'
 *   },
 * });
 */
export function useGetWeatherQuery(
  baseOptions: Apollo.QueryHookOptions<GetWeatherQuery, GetWeatherQueryVariables> &
    ({ variables: GetWeatherQueryVariables; skip?: boolean } | { skip: boolean }),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetWeatherQuery, GetWeatherQueryVariables>(GetWeatherDocument, options);
}
export function useGetWeatherLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<GetWeatherQuery, GetWeatherQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetWeatherQuery, GetWeatherQueryVariables>(
    GetWeatherDocument,
    options,
  );
}
export function useGetWeatherSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<GetWeatherQuery, GetWeatherQueryVariables>,
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<GetWeatherQuery, GetWeatherQueryVariables>(
    GetWeatherDocument,
    options,
  );
}
export type GetWeatherQueryHookResult = ReturnType<typeof useGetWeatherQuery>;
export type GetWeatherLazyQueryHookResult = ReturnType<typeof useGetWeatherLazyQuery>;
export type GetWeatherSuspenseQueryHookResult = ReturnType<typeof useGetWeatherSuspenseQuery>;
export type GetWeatherQueryResult = Apollo.QueryResult<GetWeatherQuery, GetWeatherQueryVariables>;
export const SubscribeHighlightsDocument = gql`
  subscription SubscribeHighlights($tournamentId: Id!) {
    highlight(tournamentId: $tournamentId) {
      ...HighlightFields
      hole {
        ...CourseHoleFields
      }
      participation {
        ...ParticipationFields
        players {
          ...PlayerFields
        }
      }
    }
  }
  ${HighlightFieldsFragmentDoc}
  ${CourseHoleFieldsFragmentDoc}
  ${ParticipationFieldsFragmentDoc}
  ${PlayerFieldsFragmentDoc}
`;

/**
 * __useSubscribeHighlightsSubscription__
 *
 * To run a query within a React component, call `useSubscribeHighlightsSubscription` and pass it any options that fit your needs.
 * When your component renders, `useSubscribeHighlightsSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSubscribeHighlightsSubscription({
 *   variables: {
 *      tournamentId: // value for 'tournamentId'
 *   },
 * });
 */
export function useSubscribeHighlightsSubscription(
  baseOptions: Apollo.SubscriptionHookOptions<
    SubscribeHighlightsSubscription,
    SubscribeHighlightsSubscriptionVariables
  > &
    ({ variables: SubscribeHighlightsSubscriptionVariables; skip?: boolean } | { skip: boolean }),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useSubscription<
    SubscribeHighlightsSubscription,
    SubscribeHighlightsSubscriptionVariables
  >(SubscribeHighlightsDocument, options);
}
export type SubscribeHighlightsSubscriptionHookResult = ReturnType<
  typeof useSubscribeHighlightsSubscription
>;
export type SubscribeHighlightsSubscriptionResult =
  Apollo.SubscriptionResult<SubscribeHighlightsSubscription>;
export type AnnotationKeySpecifier = (
  | 'content'
  | 'coordinates'
  | 'createdAt'
  | 'id'
  | 'updatedAt'
  | AnnotationKeySpecifier
)[];
export type AnnotationFieldPolicy = {
  content?: FieldPolicy<any> | FieldReadFunction<any>;
  coordinates?: FieldPolicy<any> | FieldReadFunction<any>;
  createdAt?: FieldPolicy<any> | FieldReadFunction<any>;
  id?: FieldPolicy<any> | FieldReadFunction<any>;
  updatedAt?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type ClubKeySpecifier = (
  | 'country'
  | 'courses'
  | 'createdAt'
  | 'foundedYear'
  | 'holes'
  | 'id'
  | 'name'
  | 'players'
  | 'slug'
  | 'updatedAt'
  | ClubKeySpecifier
)[];
export type ClubFieldPolicy = {
  country?: FieldPolicy<any> | FieldReadFunction<any>;
  courses?: FieldPolicy<any> | FieldReadFunction<any>;
  createdAt?: FieldPolicy<any> | FieldReadFunction<any>;
  foundedYear?: FieldPolicy<any> | FieldReadFunction<any>;
  holes?: FieldPolicy<any> | FieldReadFunction<any>;
  id?: FieldPolicy<any> | FieldReadFunction<any>;
  name?: FieldPolicy<any> | FieldReadFunction<any>;
  players?: FieldPolicy<any> | FieldReadFunction<any>;
  slug?: FieldPolicy<any> | FieldReadFunction<any>;
  updatedAt?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type ClubConnectionKeySpecifier = (
  | 'edges'
  | 'nodes'
  | 'pageInfo'
  | ClubConnectionKeySpecifier
)[];
export type ClubConnectionFieldPolicy = {
  edges?: FieldPolicy<any> | FieldReadFunction<any>;
  nodes?: FieldPolicy<any> | FieldReadFunction<any>;
  pageInfo?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type ClubEdgeKeySpecifier = ('cursor' | 'node' | ClubEdgeKeySpecifier)[];
export type ClubEdgeFieldPolicy = {
  cursor?: FieldPolicy<any> | FieldReadFunction<any>;
  node?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type CoordinatesKeySpecifier = (
  | 'latitude'
  | 'longitude'
  | 'system'
  | CoordinatesKeySpecifier
)[];
export type CoordinatesFieldPolicy = {
  latitude?: FieldPolicy<any> | FieldReadFunction<any>;
  longitude?: FieldPolicy<any> | FieldReadFunction<any>;
  system?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type CourseKeySpecifier = (
  | 'club'
  | 'createdAt'
  | 'holes'
  | 'id'
  | 'name'
  | 'slug'
  | 'updatedAt'
  | CourseKeySpecifier
)[];
export type CourseFieldPolicy = {
  club?: FieldPolicy<any> | FieldReadFunction<any>;
  createdAt?: FieldPolicy<any> | FieldReadFunction<any>;
  holes?: FieldPolicy<any> | FieldReadFunction<any>;
  id?: FieldPolicy<any> | FieldReadFunction<any>;
  name?: FieldPolicy<any> | FieldReadFunction<any>;
  slug?: FieldPolicy<any> | FieldReadFunction<any>;
  updatedAt?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type CourseHoleKeySpecifier = (
  | 'annotations'
  | 'clubId'
  | 'course'
  | 'createdAt'
  | 'description'
  | 'id'
  | 'imageUrl'
  | 'number'
  | 'par'
  | 'strokeIndex'
  | 'tees'
  | 'updatedAt'
  | CourseHoleKeySpecifier
)[];
export type CourseHoleFieldPolicy = {
  annotations?: FieldPolicy<any> | FieldReadFunction<any>;
  clubId?: FieldPolicy<any> | FieldReadFunction<any>;
  course?: FieldPolicy<any> | FieldReadFunction<any>;
  createdAt?: FieldPolicy<any> | FieldReadFunction<any>;
  description?: FieldPolicy<any> | FieldReadFunction<any>;
  id?: FieldPolicy<any> | FieldReadFunction<any>;
  imageUrl?: FieldPolicy<any> | FieldReadFunction<any>;
  number?: FieldPolicy<any> | FieldReadFunction<any>;
  par?: FieldPolicy<any> | FieldReadFunction<any>;
  strokeIndex?: FieldPolicy<any> | FieldReadFunction<any>;
  tees?: FieldPolicy<any> | FieldReadFunction<any>;
  updatedAt?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type HighlightKeySpecifier = (
  | 'content'
  | 'createdAt'
  | 'display'
  | 'duration'
  | 'expirationAt'
  | 'hole'
  | 'id'
  | 'participation'
  | 'priority'
  | 'repeat'
  | 'title'
  | HighlightKeySpecifier
)[];
export type HighlightFieldPolicy = {
  content?: FieldPolicy<any> | FieldReadFunction<any>;
  createdAt?: FieldPolicy<any> | FieldReadFunction<any>;
  display?: FieldPolicy<any> | FieldReadFunction<any>;
  duration?: FieldPolicy<any> | FieldReadFunction<any>;
  expirationAt?: FieldPolicy<any> | FieldReadFunction<any>;
  hole?: FieldPolicy<any> | FieldReadFunction<any>;
  id?: FieldPolicy<any> | FieldReadFunction<any>;
  participation?: FieldPolicy<any> | FieldReadFunction<any>;
  priority?: FieldPolicy<any> | FieldReadFunction<any>;
  repeat?: FieldPolicy<any> | FieldReadFunction<any>;
  title?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type HighlightEventKeySpecifier = ('type' | HighlightEventKeySpecifier)[];
export type HighlightEventFieldPolicy = {
  type?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type HighlightMediaKeySpecifier = (
  | 'location'
  | 'mimeType'
  | 'sizeBytes'
  | 'thumbnailUrl'
  | 'url'
  | HighlightMediaKeySpecifier
)[];
export type HighlightMediaFieldPolicy = {
  location?: FieldPolicy<any> | FieldReadFunction<any>;
  mimeType?: FieldPolicy<any> | FieldReadFunction<any>;
  sizeBytes?: FieldPolicy<any> | FieldReadFunction<any>;
  thumbnailUrl?: FieldPolicy<any> | FieldReadFunction<any>;
  url?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type HoleKeySpecifier = (
  | 'annotations'
  | 'courses'
  | 'createdAt'
  | 'description'
  | 'id'
  | 'imageUrl'
  | 'number'
  | 'par'
  | 'strokeIndex'
  | 'tees'
  | 'updatedAt'
  | HoleKeySpecifier
)[];
export type HoleFieldPolicy = {
  annotations?: FieldPolicy<any> | FieldReadFunction<any>;
  courses?: FieldPolicy<any> | FieldReadFunction<any>;
  createdAt?: FieldPolicy<any> | FieldReadFunction<any>;
  description?: FieldPolicy<any> | FieldReadFunction<any>;
  id?: FieldPolicy<any> | FieldReadFunction<any>;
  imageUrl?: FieldPolicy<any> | FieldReadFunction<any>;
  number?: FieldPolicy<any> | FieldReadFunction<any>;
  par?: FieldPolicy<any> | FieldReadFunction<any>;
  strokeIndex?: FieldPolicy<any> | FieldReadFunction<any>;
  tees?: FieldPolicy<any> | FieldReadFunction<any>;
  updatedAt?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type LatLngKeySpecifier = ('latitude' | 'longitude' | LatLngKeySpecifier)[];
export type LatLngFieldPolicy = {
  latitude?: FieldPolicy<any> | FieldReadFunction<any>;
  longitude?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type LeaderBoardKeySpecifier = (
  | 'ranking'
  | 'rounds'
  | 'tiePolicy'
  | 'tournament'
  | LeaderBoardKeySpecifier
)[];
export type LeaderBoardFieldPolicy = {
  ranking?: FieldPolicy<any> | FieldReadFunction<any>;
  rounds?: FieldPolicy<any> | FieldReadFunction<any>;
  tiePolicy?: FieldPolicy<any> | FieldReadFunction<any>;
  tournament?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type LeaderBoardRankingEntryKeySpecifier = (
  | 'participation'
  | 'playedHoles'
  | 'score'
  | LeaderBoardRankingEntryKeySpecifier
)[];
export type LeaderBoardRankingEntryFieldPolicy = {
  participation?: FieldPolicy<any> | FieldReadFunction<any>;
  playedHoles?: FieldPolicy<any> | FieldReadFunction<any>;
  score?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type LeaderBoardRoundKeySpecifier = (
  | 'ranking'
  | 'round'
  | 'tiePolicy'
  | LeaderBoardRoundKeySpecifier
)[];
export type LeaderBoardRoundFieldPolicy = {
  ranking?: FieldPolicy<any> | FieldReadFunction<any>;
  round?: FieldPolicy<any> | FieldReadFunction<any>;
  tiePolicy?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type MutationRootKeySpecifier = ('createClub' | 'createPlayer' | MutationRootKeySpecifier)[];
export type MutationRootFieldPolicy = {
  createClub?: FieldPolicy<any> | FieldReadFunction<any>;
  createPlayer?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type PageInfoKeySpecifier = (
  | 'endCursor'
  | 'hasNextPage'
  | 'hasPreviousPage'
  | 'startCursor'
  | PageInfoKeySpecifier
)[];
export type PageInfoFieldPolicy = {
  endCursor?: FieldPolicy<any> | FieldReadFunction<any>;
  hasNextPage?: FieldPolicy<any> | FieldReadFunction<any>;
  hasPreviousPage?: FieldPolicy<any> | FieldReadFunction<any>;
  startCursor?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type ParticipationKeySpecifier = (
  | 'created_at'
  | 'depth'
  | 'id'
  | 'lastScoredHole'
  | 'parentId'
  | 'players'
  | 'round'
  | 'startHole'
  | 'status'
  | 'teeTime'
  | 'type'
  | 'updated_at'
  | ParticipationKeySpecifier
)[];
export type ParticipationFieldPolicy = {
  created_at?: FieldPolicy<any> | FieldReadFunction<any>;
  depth?: FieldPolicy<any> | FieldReadFunction<any>;
  id?: FieldPolicy<any> | FieldReadFunction<any>;
  lastScoredHole?: FieldPolicy<any> | FieldReadFunction<any>;
  parentId?: FieldPolicy<any> | FieldReadFunction<any>;
  players?: FieldPolicy<any> | FieldReadFunction<any>;
  round?: FieldPolicy<any> | FieldReadFunction<any>;
  startHole?: FieldPolicy<any> | FieldReadFunction<any>;
  status?: FieldPolicy<any> | FieldReadFunction<any>;
  teeTime?: FieldPolicy<any> | FieldReadFunction<any>;
  type?: FieldPolicy<any> | FieldReadFunction<any>;
  updated_at?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type PlayerKeySpecifier = (
  | 'club'
  | 'country'
  | 'createdAt'
  | 'firstName'
  | 'id'
  | 'lastName'
  | 'license'
  | 'status'
  | 'updatedAt'
  | PlayerKeySpecifier
)[];
export type PlayerFieldPolicy = {
  club?: FieldPolicy<any> | FieldReadFunction<any>;
  country?: FieldPolicy<any> | FieldReadFunction<any>;
  createdAt?: FieldPolicy<any> | FieldReadFunction<any>;
  firstName?: FieldPolicy<any> | FieldReadFunction<any>;
  id?: FieldPolicy<any> | FieldReadFunction<any>;
  lastName?: FieldPolicy<any> | FieldReadFunction<any>;
  license?: FieldPolicy<any> | FieldReadFunction<any>;
  status?: FieldPolicy<any> | FieldReadFunction<any>;
  updatedAt?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type PlayerConnectionKeySpecifier = (
  | 'edges'
  | 'nodes'
  | 'pageInfo'
  | PlayerConnectionKeySpecifier
)[];
export type PlayerConnectionFieldPolicy = {
  edges?: FieldPolicy<any> | FieldReadFunction<any>;
  nodes?: FieldPolicy<any> | FieldReadFunction<any>;
  pageInfo?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type PlayerEdgeKeySpecifier = ('cursor' | 'node' | PlayerEdgeKeySpecifier)[];
export type PlayerEdgeFieldPolicy = {
  cursor?: FieldPolicy<any> | FieldReadFunction<any>;
  node?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type QueryRootKeySpecifier = (
  | 'club'
  | 'clubs'
  | 'course'
  | 'courses'
  | 'hole'
  | 'holes'
  | 'leaderBoard'
  | 'player'
  | 'playerLiveStats'
  | 'players'
  | 'round'
  | 'rounds'
  | 'scoreCard'
  | 'tournament'
  | 'tournaments'
  | 'weather'
  | QueryRootKeySpecifier
)[];
export type QueryRootFieldPolicy = {
  club?: FieldPolicy<any> | FieldReadFunction<any>;
  clubs?: FieldPolicy<any> | FieldReadFunction<any>;
  course?: FieldPolicy<any> | FieldReadFunction<any>;
  courses?: FieldPolicy<any> | FieldReadFunction<any>;
  hole?: FieldPolicy<any> | FieldReadFunction<any>;
  holes?: FieldPolicy<any> | FieldReadFunction<any>;
  leaderBoard?: FieldPolicy<any> | FieldReadFunction<any>;
  player?: FieldPolicy<any> | FieldReadFunction<any>;
  playerLiveStats?: FieldPolicy<any> | FieldReadFunction<any>;
  players?: FieldPolicy<any> | FieldReadFunction<any>;
  round?: FieldPolicy<any> | FieldReadFunction<any>;
  rounds?: FieldPolicy<any> | FieldReadFunction<any>;
  scoreCard?: FieldPolicy<any> | FieldReadFunction<any>;
  tournament?: FieldPolicy<any> | FieldReadFunction<any>;
  tournaments?: FieldPolicy<any> | FieldReadFunction<any>;
  weather?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type RoundKeySpecifier = (
  | 'course'
  | 'createdAt'
  | 'endedAt'
  | 'holes'
  | 'id'
  | 'ordinal'
  | 'participationDepth'
  | 'participations'
  | 'playFormat'
  | 'startedAt'
  | 'status'
  | 'tournament'
  | 'updatedAt'
  | RoundKeySpecifier
)[];
export type RoundFieldPolicy = {
  course?: FieldPolicy<any> | FieldReadFunction<any>;
  createdAt?: FieldPolicy<any> | FieldReadFunction<any>;
  endedAt?: FieldPolicy<any> | FieldReadFunction<any>;
  holes?: FieldPolicy<any> | FieldReadFunction<any>;
  id?: FieldPolicy<any> | FieldReadFunction<any>;
  ordinal?: FieldPolicy<any> | FieldReadFunction<any>;
  participationDepth?: FieldPolicy<any> | FieldReadFunction<any>;
  participations?: FieldPolicy<any> | FieldReadFunction<any>;
  playFormat?: FieldPolicy<any> | FieldReadFunction<any>;
  startedAt?: FieldPolicy<any> | FieldReadFunction<any>;
  status?: FieldPolicy<any> | FieldReadFunction<any>;
  tournament?: FieldPolicy<any> | FieldReadFunction<any>;
  updatedAt?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type ScoreAggregationPolicyKeySpecifier = (
  | 'kind'
  | 'n'
  | ScoreAggregationPolicyKeySpecifier
)[];
export type ScoreAggregationPolicyFieldPolicy = {
  kind?: FieldPolicy<any> | FieldReadFunction<any>;
  n?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type ScoreCardKeySpecifier = (
  | 'aggregationPolicy'
  | 'back'
  | 'front'
  | 'holes'
  | 'participation'
  | 'playedHoles'
  | 'round'
  | 'total'
  | 'totalHoles'
  | 'tournament'
  | ScoreCardKeySpecifier
)[];
export type ScoreCardFieldPolicy = {
  aggregationPolicy?: FieldPolicy<any> | FieldReadFunction<any>;
  back?: FieldPolicy<any> | FieldReadFunction<any>;
  front?: FieldPolicy<any> | FieldReadFunction<any>;
  holes?: FieldPolicy<any> | FieldReadFunction<any>;
  participation?: FieldPolicy<any> | FieldReadFunction<any>;
  playedHoles?: FieldPolicy<any> | FieldReadFunction<any>;
  round?: FieldPolicy<any> | FieldReadFunction<any>;
  total?: FieldPolicy<any> | FieldReadFunction<any>;
  totalHoles?: FieldPolicy<any> | FieldReadFunction<any>;
  tournament?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type ScoreCardHoleKeySpecifier = (
  | 'createdAt'
  | 'handicap'
  | 'holeNumber'
  | 'par'
  | 'result'
  | 'updatedAt'
  | ScoreCardHoleKeySpecifier
)[];
export type ScoreCardHoleFieldPolicy = {
  createdAt?: FieldPolicy<any> | FieldReadFunction<any>;
  handicap?: FieldPolicy<any> | FieldReadFunction<any>;
  holeNumber?: FieldPolicy<any> | FieldReadFunction<any>;
  par?: FieldPolicy<any> | FieldReadFunction<any>;
  result?: FieldPolicy<any> | FieldReadFunction<any>;
  updatedAt?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type ScoreEntryKeySpecifier = (
  | 'stableford'
  | 'strokes'
  | 'toPar'
  | ScoreEntryKeySpecifier
)[];
export type ScoreEntryFieldPolicy = {
  stableford?: FieldPolicy<any> | FieldReadFunction<any>;
  strokes?: FieldPolicy<any> | FieldReadFunction<any>;
  toPar?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type ScoreSpecialKeySpecifier = ('kind' | 'notes' | ScoreSpecialKeySpecifier)[];
export type ScoreSpecialFieldPolicy = {
  kind?: FieldPolicy<any> | FieldReadFunction<any>;
  notes?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type SubscribePlayerGeopositionResponseKeySpecifier = (
  | 'coordinates'
  | 'player'
  | 'timestamp'
  | SubscribePlayerGeopositionResponseKeySpecifier
)[];
export type SubscribePlayerGeopositionResponseFieldPolicy = {
  coordinates?: FieldPolicy<any> | FieldReadFunction<any>;
  player?: FieldPolicy<any> | FieldReadFunction<any>;
  timestamp?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type SubscriptionRootKeySpecifier = (
  | 'highlight'
  | 'playerTracking'
  | SubscriptionRootKeySpecifier
)[];
export type SubscriptionRootFieldPolicy = {
  highlight?: FieldPolicy<any> | FieldReadFunction<any>;
  playerTracking?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type TeeBarKeySpecifier = (
  | 'color'
  | 'createdAt'
  | 'gender'
  | 'length'
  | 'pace'
  | 'strokeIndex'
  | 'updatedAt'
  | TeeBarKeySpecifier
)[];
export type TeeBarFieldPolicy = {
  color?: FieldPolicy<any> | FieldReadFunction<any>;
  createdAt?: FieldPolicy<any> | FieldReadFunction<any>;
  gender?: FieldPolicy<any> | FieldReadFunction<any>;
  length?: FieldPolicy<any> | FieldReadFunction<any>;
  pace?: FieldPolicy<any> | FieldReadFunction<any>;
  strokeIndex?: FieldPolicy<any> | FieldReadFunction<any>;
  updatedAt?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type TieBreakPolicyKeySpecifier = ('steps' | TieBreakPolicyKeySpecifier)[];
export type TieBreakPolicyFieldPolicy = {
  steps?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type TieBreakSpecKeySpecifier = (
  | 'direction'
  | 'field'
  | 'kind'
  | 'lastNHoles'
  | 'note'
  | TieBreakSpecKeySpecifier
)[];
export type TieBreakSpecFieldPolicy = {
  direction?: FieldPolicy<any> | FieldReadFunction<any>;
  field?: FieldPolicy<any> | FieldReadFunction<any>;
  kind?: FieldPolicy<any> | FieldReadFunction<any>;
  lastNHoles?: FieldPolicy<any> | FieldReadFunction<any>;
  note?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type TournamentKeySpecifier = (
  | 'capacity'
  | 'createdAt'
  | 'host'
  | 'id'
  | 'inscriptionMode'
  | 'name'
  | 'organizer'
  | 'players'
  | 'rounds'
  | 'scoringSystem'
  | 'status'
  | 'updatedAt'
  | TournamentKeySpecifier
)[];
export type TournamentFieldPolicy = {
  capacity?: FieldPolicy<any> | FieldReadFunction<any>;
  createdAt?: FieldPolicy<any> | FieldReadFunction<any>;
  host?: FieldPolicy<any> | FieldReadFunction<any>;
  id?: FieldPolicy<any> | FieldReadFunction<any>;
  inscriptionMode?: FieldPolicy<any> | FieldReadFunction<any>;
  name?: FieldPolicy<any> | FieldReadFunction<any>;
  organizer?: FieldPolicy<any> | FieldReadFunction<any>;
  players?: FieldPolicy<any> | FieldReadFunction<any>;
  rounds?: FieldPolicy<any> | FieldReadFunction<any>;
  scoringSystem?: FieldPolicy<any> | FieldReadFunction<any>;
  status?: FieldPolicy<any> | FieldReadFunction<any>;
  updatedAt?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type TournamentConnectionKeySpecifier = (
  | 'edges'
  | 'nodes'
  | 'pageInfo'
  | TournamentConnectionKeySpecifier
)[];
export type TournamentConnectionFieldPolicy = {
  edges?: FieldPolicy<any> | FieldReadFunction<any>;
  nodes?: FieldPolicy<any> | FieldReadFunction<any>;
  pageInfo?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type TournamentEdgeKeySpecifier = ('cursor' | 'node' | TournamentEdgeKeySpecifier)[];
export type TournamentEdgeFieldPolicy = {
  cursor?: FieldPolicy<any> | FieldReadFunction<any>;
  node?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type WeatherKeySpecifier = (
  | 'condition'
  | 'humidityPercent'
  | 'observedAt'
  | 'precipitationMm'
  | 'pressureHpa'
  | 'temperature'
  | 'temperatureRange'
  | 'wind'
  | WeatherKeySpecifier
)[];
export type WeatherFieldPolicy = {
  condition?: FieldPolicy<any> | FieldReadFunction<any>;
  humidityPercent?: FieldPolicy<any> | FieldReadFunction<any>;
  observedAt?: FieldPolicy<any> | FieldReadFunction<any>;
  precipitationMm?: FieldPolicy<any> | FieldReadFunction<any>;
  pressureHpa?: FieldPolicy<any> | FieldReadFunction<any>;
  temperature?: FieldPolicy<any> | FieldReadFunction<any>;
  temperatureRange?: FieldPolicy<any> | FieldReadFunction<any>;
  wind?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type WeatherTemperatureKeySpecifier = (
  | 'celsius'
  | 'fahrenheit'
  | WeatherTemperatureKeySpecifier
)[];
export type WeatherTemperatureFieldPolicy = {
  celsius?: FieldPolicy<any> | FieldReadFunction<any>;
  fahrenheit?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type WeatherTemperatureRangeKeySpecifier = (
  | 'avgCelsius'
  | 'maxCelsius'
  | 'minCelsius'
  | WeatherTemperatureRangeKeySpecifier
)[];
export type WeatherTemperatureRangeFieldPolicy = {
  avgCelsius?: FieldPolicy<any> | FieldReadFunction<any>;
  maxCelsius?: FieldPolicy<any> | FieldReadFunction<any>;
  minCelsius?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type WeatherWindKeySpecifier = (
  | 'directionCardinal'
  | 'directionDegrees'
  | 'speedKph'
  | 'speedMph'
  | 'speedMs'
  | WeatherWindKeySpecifier
)[];
export type WeatherWindFieldPolicy = {
  directionCardinal?: FieldPolicy<any> | FieldReadFunction<any>;
  directionDegrees?: FieldPolicy<any> | FieldReadFunction<any>;
  speedKph?: FieldPolicy<any> | FieldReadFunction<any>;
  speedMph?: FieldPolicy<any> | FieldReadFunction<any>;
  speedMs?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type StrictTypedTypePolicies = {
  Annotation?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?: false | AnnotationKeySpecifier | (() => undefined | AnnotationKeySpecifier);
    fields?: AnnotationFieldPolicy;
  };
  Club?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?: false | ClubKeySpecifier | (() => undefined | ClubKeySpecifier);
    fields?: ClubFieldPolicy;
  };
  ClubConnection?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?: false | ClubConnectionKeySpecifier | (() => undefined | ClubConnectionKeySpecifier);
    fields?: ClubConnectionFieldPolicy;
  };
  ClubEdge?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?: false | ClubEdgeKeySpecifier | (() => undefined | ClubEdgeKeySpecifier);
    fields?: ClubEdgeFieldPolicy;
  };
  Coordinates?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?: false | CoordinatesKeySpecifier | (() => undefined | CoordinatesKeySpecifier);
    fields?: CoordinatesFieldPolicy;
  };
  Course?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?: false | CourseKeySpecifier | (() => undefined | CourseKeySpecifier);
    fields?: CourseFieldPolicy;
  };
  CourseHole?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?: false | CourseHoleKeySpecifier | (() => undefined | CourseHoleKeySpecifier);
    fields?: CourseHoleFieldPolicy;
  };
  Highlight?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?: false | HighlightKeySpecifier | (() => undefined | HighlightKeySpecifier);
    fields?: HighlightFieldPolicy;
  };
  HighlightEvent?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?: false | HighlightEventKeySpecifier | (() => undefined | HighlightEventKeySpecifier);
    fields?: HighlightEventFieldPolicy;
  };
  HighlightMedia?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?: false | HighlightMediaKeySpecifier | (() => undefined | HighlightMediaKeySpecifier);
    fields?: HighlightMediaFieldPolicy;
  };
  Hole?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?: false | HoleKeySpecifier | (() => undefined | HoleKeySpecifier);
    fields?: HoleFieldPolicy;
  };
  LatLng?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?: false | LatLngKeySpecifier | (() => undefined | LatLngKeySpecifier);
    fields?: LatLngFieldPolicy;
  };
  LeaderBoard?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?: false | LeaderBoardKeySpecifier | (() => undefined | LeaderBoardKeySpecifier);
    fields?: LeaderBoardFieldPolicy;
  };
  LeaderBoardRankingEntry?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | LeaderBoardRankingEntryKeySpecifier
      | (() => undefined | LeaderBoardRankingEntryKeySpecifier);
    fields?: LeaderBoardRankingEntryFieldPolicy;
  };
  LeaderBoardRound?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | LeaderBoardRoundKeySpecifier
      | (() => undefined | LeaderBoardRoundKeySpecifier);
    fields?: LeaderBoardRoundFieldPolicy;
  };
  MutationRoot?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?: false | MutationRootKeySpecifier | (() => undefined | MutationRootKeySpecifier);
    fields?: MutationRootFieldPolicy;
  };
  PageInfo?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?: false | PageInfoKeySpecifier | (() => undefined | PageInfoKeySpecifier);
    fields?: PageInfoFieldPolicy;
  };
  Participation?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?: false | ParticipationKeySpecifier | (() => undefined | ParticipationKeySpecifier);
    fields?: ParticipationFieldPolicy;
  };
  Player?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?: false | PlayerKeySpecifier | (() => undefined | PlayerKeySpecifier);
    fields?: PlayerFieldPolicy;
  };
  PlayerConnection?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | PlayerConnectionKeySpecifier
      | (() => undefined | PlayerConnectionKeySpecifier);
    fields?: PlayerConnectionFieldPolicy;
  };
  PlayerEdge?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?: false | PlayerEdgeKeySpecifier | (() => undefined | PlayerEdgeKeySpecifier);
    fields?: PlayerEdgeFieldPolicy;
  };
  QueryRoot?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?: false | QueryRootKeySpecifier | (() => undefined | QueryRootKeySpecifier);
    fields?: QueryRootFieldPolicy;
  };
  Round?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?: false | RoundKeySpecifier | (() => undefined | RoundKeySpecifier);
    fields?: RoundFieldPolicy;
  };
  ScoreAggregationPolicy?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | ScoreAggregationPolicyKeySpecifier
      | (() => undefined | ScoreAggregationPolicyKeySpecifier);
    fields?: ScoreAggregationPolicyFieldPolicy;
  };
  ScoreCard?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?: false | ScoreCardKeySpecifier | (() => undefined | ScoreCardKeySpecifier);
    fields?: ScoreCardFieldPolicy;
  };
  ScoreCardHole?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?: false | ScoreCardHoleKeySpecifier | (() => undefined | ScoreCardHoleKeySpecifier);
    fields?: ScoreCardHoleFieldPolicy;
  };
  ScoreEntry?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?: false | ScoreEntryKeySpecifier | (() => undefined | ScoreEntryKeySpecifier);
    fields?: ScoreEntryFieldPolicy;
  };
  ScoreSpecial?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?: false | ScoreSpecialKeySpecifier | (() => undefined | ScoreSpecialKeySpecifier);
    fields?: ScoreSpecialFieldPolicy;
  };
  SubscribePlayerGeopositionResponse?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | SubscribePlayerGeopositionResponseKeySpecifier
      | (() => undefined | SubscribePlayerGeopositionResponseKeySpecifier);
    fields?: SubscribePlayerGeopositionResponseFieldPolicy;
  };
  SubscriptionRoot?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | SubscriptionRootKeySpecifier
      | (() => undefined | SubscriptionRootKeySpecifier);
    fields?: SubscriptionRootFieldPolicy;
  };
  TeeBar?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?: false | TeeBarKeySpecifier | (() => undefined | TeeBarKeySpecifier);
    fields?: TeeBarFieldPolicy;
  };
  TieBreakPolicy?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?: false | TieBreakPolicyKeySpecifier | (() => undefined | TieBreakPolicyKeySpecifier);
    fields?: TieBreakPolicyFieldPolicy;
  };
  TieBreakSpec?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?: false | TieBreakSpecKeySpecifier | (() => undefined | TieBreakSpecKeySpecifier);
    fields?: TieBreakSpecFieldPolicy;
  };
  Tournament?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?: false | TournamentKeySpecifier | (() => undefined | TournamentKeySpecifier);
    fields?: TournamentFieldPolicy;
  };
  TournamentConnection?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | TournamentConnectionKeySpecifier
      | (() => undefined | TournamentConnectionKeySpecifier);
    fields?: TournamentConnectionFieldPolicy;
  };
  TournamentEdge?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?: false | TournamentEdgeKeySpecifier | (() => undefined | TournamentEdgeKeySpecifier);
    fields?: TournamentEdgeFieldPolicy;
  };
  Weather?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?: false | WeatherKeySpecifier | (() => undefined | WeatherKeySpecifier);
    fields?: WeatherFieldPolicy;
  };
  WeatherTemperature?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | WeatherTemperatureKeySpecifier
      | (() => undefined | WeatherTemperatureKeySpecifier);
    fields?: WeatherTemperatureFieldPolicy;
  };
  WeatherTemperatureRange?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | WeatherTemperatureRangeKeySpecifier
      | (() => undefined | WeatherTemperatureRangeKeySpecifier);
    fields?: WeatherTemperatureRangeFieldPolicy;
  };
  WeatherWind?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?: false | WeatherWindKeySpecifier | (() => undefined | WeatherWindKeySpecifier);
    fields?: WeatherWindFieldPolicy;
  };
};
export type TypedTypePolicies = StrictTypedTypePolicies & TypePolicies;
